import { render, staticRenderFns } from "./Narocila.vue?vue&type=template&id=5e1e8d53&"
import script from "./Narocila.vue?vue&type=script&lang=js&"
export * from "./Narocila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports